<form>
  <!-- Modal Header -->
  <div class="modal-header" style="background-color: lightseagreen">
    <h4 class="modal-title">Add Toting</h4>
    <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()"></button>
  </div>

  <div class="modal-body">
    <!--Account Number-->
    <div class="row p-3 d-flex justify-content-center align-items-center">
      <div class="col-12">
        <p>From Account</p>
      </div>
      <div class="col-12">
        <select class="browser-default form-select" name="selectedAccount" [(ngModel)]="selectedAccountId">
          <optgroup label="Company Account">
            @for (account of companyBankAccountList; track account) {
              <option [value]="account.ID" [selected]="setSelectedAccount(account.ID)">{{ account.Name }} (RM {{ account.Balance || 0 }})</option>
            }
          </optgroup>

          <optgroup label="Cash Account">
            @for (account of cashAccountList; track account) {
              <option [value]="account.ID" [selected]="setSelectedAccount(account.ID)">{{ account.Name }} (RM {{ account.Balance || 0 }})</option>
            }
          </optgroup>
        </select>
      </div>
    </div>

    <!--Is Return-->
    <div class="row mb-5">
      <div class="col">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" id="checkboxReturn" name="isReturn" [value]="isReturn" [(ngModel)]="isReturn" style="top: 10px" />
          <label class="form-check-label" for="checkboxReturn" style="top: 0px; color: blue; font-weight: bold; font-size: 1.2rem">Return</label>
        </div>
      </div>
    </div>

    <!--Amount-->

    <div class="card">
      <div class="card-header">Toting Details</div>
      <div class="card-body">
        <div class="group">
          <input type="number" required class="textInputLong" name="amount" [(ngModel)]="amount" min="0" (keypress)="sharedService.isNumberKey($event)" />
          <span class="highlight"></span>
          <span class="bar barLong"></span>
          <label>Amount</label>
        </div>
      </div>
    </div>

    <!--Date-->
    <mat-form-field class="full-width-formField bar">
      <input matInput class="textInputLong" [matDatepicker]="myDatepicker" name="totingDate" [(ngModel)]="totingDate" placeholder="Toting Date" [max]="sharedService.getTodayDate()" onkeydown="return false;" />
      <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
      <mat-datepicker #myDatepicker name="totingDate"></mat-datepicker>
    </mat-form-field>

    <!--Remark-->
    <div class="group">
      <input type="text" required class="textInputLong" name="remark" [(ngModel)]="remark" />
      <span class="highlight"></span>
      <span class="bar barLong"></span>
      <label> Remark</label>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-outline-success" type="button" (click)="submit()" [disabled]="disabledSubmit">Add Toting</button>
    <button class="btn btn-outline-danger" type="button" (click)="reset()">Cancel</button>
  </div>
</form>
